import styled from '@emotion/styled/macro'
import { Box, Button } from '@mui/material'
import theme from 'theme'

export const AccountWrapper = styled(Box)`
  width: 584px;
  margin: 0 auto;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background: ${theme.colors.surfaceContainerBackground};
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`

export const CompanyHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 32px;

  .logo-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 100px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .company-name {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 20px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.1px;
  }
`

export const CompanyInfoSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .section-title {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 16px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.1px;
  }
`

export const InfoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 48px;

  .icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.devicesRowHoverBg};
    border-radius: ${theme.attributes.borderRadius.tertiary};
    flex-shrink: 0;

    svg path {
      stroke: ${theme.colors.dropdownLabel};
    }
  }

  .info-content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .info-label {
      color: ${theme.colors.devicesSecondaryText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 14px;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 22px;
    }

    .info-value {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 14px;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.1px;
    }
  }
`

export const EditButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  padding: 8px 24px 8px 16px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background: ${theme.colors.btnTertiaryBg};
  text-transform: none;

  svg path {
    stroke: ${theme.colors.cta};
  }

  &:hover {
    background: ${theme.colors.tooltipBg};
  }

  &:disabled {
    background: ${theme.colors.devicesRowHoverBg};
    opacity: 0.5;

    svg path {
      stroke: ${theme.colors.btnSecondaryDisabledText};
    }

    .button-text {
      color: ${theme.colors.btnSecondaryDisabledText};
    }
  }

  .button-text {
    color: ${theme.colors.cta};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: ${theme.typography.fontWeight.normal};

    html[data-theme='light'] & {
      font-weight: ${theme.typography.fontWeight.bold};
    }
    line-height: 22px;
    text-align: center;
  }
`
